import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M19.917 30q.874 0 1.48-.605.604-.605.603-1.478 0-.876-.603-1.48a2 2 0 0 0-1.48-.604q-.875 0-1.479.605a2.02 2.02 0 0 0-.605 1.479q0 .874.605 1.48.605.604 1.479.603m.25-17.167q1.166 0 1.875.645.708.645.708 1.689 0 .708-.478 1.436-.479.729-1.355 1.522-1.25 1.084-1.834 2.083-.582 1-.583 2 0 .585.438.98.44.397 1.02.395.585 0 1.042-.416.459-.417.583-1.042.126-.708.564-1.313t1.436-1.562q1.292-1.209 1.814-2.208a4.7 4.7 0 0 0 .52-2.209q0-2.125-1.605-3.478T20.167 10q-1.75 0-3.104.667-1.352.667-2.105 2.041-.291.542-.208 1.064.084.521.583.853.542.333 1.189.208.646-.125 1.061-.708a3.16 3.16 0 0 1 1.104-.958q.645-.334 1.48-.334M20 36.667q-3.416 0-6.458-1.314-3.042-1.312-5.314-3.561-2.27-2.25-3.583-5.292T3.333 20q0-3.459 1.314-6.5Q5.96 10.458 8.23 8.208t5.31-3.561T20 3.333q3.5 0 6.542 1.314 3.04 1.313 5.291 3.561 2.25 2.25 3.542 5.292t1.292 6.5-1.292 6.5-3.542 5.292-5.291 3.563T20 36.667m0-3.334q5.583 0 9.458-3.895T33.333 20q0-5.541-3.875-9.438T20 6.667q-5.458 0-9.397 3.895Q6.666 14.456 6.667 20q0 5.541 3.938 9.438T20 33.333"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }